// VOLUME widget - backed by the shared PRICE data tool (whose price_history
// rows already carry volume + adtv); the standalone VOLUME pipeline was removed.
import type { RangeOption } from '../../../blocks/chart-widget';

export type VolumeChartRange = '1M' | '3M' | '1Y' | '5Y' | '10Y';

export const VOLUME_RANGE_OPTIONS: Array<RangeOption & { value: VolumeChartRange }> = [
  { value: '1M', label: '1M', rows: 21 },
  { value: '3M', label: '3M', rows: 63 },
  { value: '1Y', label: '1Y', rows: 252 },
  { value: '5Y', label: '5Y', rows: 1260 },
  { value: '10Y', label: '10Y', rows: 2520 },
];

export interface VolumeWidgetConfig {
  /** Trading days for ADTV rolling average (default: 63, roughly 3 months) */
  adtv_window?: number;
  /** Initially selected chart range (user can change it on the widget). */
  defaultRange?: VolumeChartRange;
}

export interface VolumeWidgetInstanceConfig extends VolumeWidgetConfig {
  dataKey?: string;
}

// API response shape from POST /datasources/widgets -> PRICE
export interface VolumeHistoryRow {
  date: string;
  price?: number;
  volume: number;
  adtv: number;
}

export interface VolumeData {
  ticker: string;
  latest_volume: number | null;
  adtv_3m: number | null;
  price_history: VolumeHistoryRow[] | null;
}
